import React, { useState, useEffect } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';
import { isNativeImageLazyLoadingSupported } from '~helpers/device-detect';
import { isBrowserWebpCompatable } from '~helpers/getters';

export default function LazyImage({
  height,
  width,
  style = {},
  className,
  src = '#',
  alt = 'missing alt',
  defaultImg,
  loading = 'lazy',
}) {
  const [errorImage, setErrorImage] = useState(false);
  const [nonNativeLazyLoaded, setNonNativeLazyLoaded] = useState(false);
  const [imageSrc, setImageSrc] = useState(src);

  useEffect(() => {
    setNonNativeLazyLoaded(!isNativeImageLazyLoadingSupported());
    isBrowserWebpCompatable('lossy', (_feature, isSupported) => {
      if (!isSupported && src) {
        setImageSrc(src.replace('filters:format(webp)/', ''));
      }
    });
  }, [src]);

  if ((defaultImg && !src) || errorImage === true) {
    return defaultImg;
  }

  return !nonNativeLazyLoaded ? (
    <img
      src={imageSrc}
      loading={loading}
      className={className}
      height={height}
      width={width}
      alt={alt}
      style={style}
      onError={() => setErrorImage(true)}
    />
  ) : (
    <>
      <LazyLoad
        height={height ? `${height}px` : null}
        width={width ? `${width}px` : null}
        placeholder={<span className="lazyload-placeholder" />}
        debounce={0}
      >
        <img
          src={imageSrc}
          className={className}
          height={height}
          width={width}
          alt={alt}
          style={style}
        />
      </LazyLoad>
      <noscript>
        <img
          src={imageSrc}
          className={className}
          height={height}
          width={width}
          alt={alt}
          style={style}
        />
      </noscript>
    </>
  );
}

LazyImage.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  style: PropTypes.shape({}),
  className: PropTypes.string,
  src: PropTypes.string,
  alt: PropTypes.string,
  defaultImg: PropTypes.element,
  loading: PropTypes.string,
};
